import { getCompany, deliveryPrice, getOrderDelivery, editDelivery } from '@/api/delivery'


class deliveryDTO {
    /**
     * 获取物流公司
     */
    static getCompanyList() {
        return new Promise((resolve, reject) => {
            getCompany().then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 获取配送价格
     * params 省市区信息
     */
    static getDeliveryPrice(params){
        return new Promise((resolve, reject) => {
            deliveryPrice(params).then(res => {
                resolve(res)
            })
        })
    }
    /**
     * 查询订单快递信息
     */
    static getOrderDelivery(params){
        return new Promise((resolve, reject) => {
            getOrderDelivery(params).then(res => {
                resolve(res)
            })
        })
    }
    /**
     * 编辑配送信息
     */
    static editDelivery(params){
        return new Promise((resolve, reject) => {
            editDelivery(params).then(res => {
                resolve(res)
            })
        })
    }
}

export { deliveryDTO }